import type { Locale } from "@/lib/i18n";
import { pl, type CNestedCatalogsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cNestedCatalogsTranslations: Record<Locale, CNestedCatalogsTranslations> = {
  pl,
  en,
  de,
};

export type { CNestedCatalogsTranslations };
